import { useState, useEffect } from "react";

export default function CountdownTimer({ targetDate, label = "Enrollment Closes In", accentColor = "#E32636" }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = new Date(targetDate) - new Date();
    if (difference <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetDate]);

  const timeBlocks = [
    { value: timeLeft.days, label: "Days" },
    { value: timeLeft.hours, label: "Hours" },
    { value: timeLeft.minutes, label: "Min" },
    { value: timeLeft.seconds, label: "Sec" },
  ];

  return (
    <div
      data-testid="countdown-timer"
      className="w-full p-6 bg-[#16161F] border rounded-md"
      style={{ borderColor: `${accentColor}66`, boxShadow: `0 0 20px ${accentColor}22, 0 0 60px ${accentColor}08` }}
    >
      <p
        className="font-['Space_Grotesk'] text-xs font-semibold uppercase tracking-widest mb-4 text-center font-mono"
        style={{ color: accentColor }}
      >
        {label}
      </p>
      <div className="grid grid-cols-4 gap-3">
        {timeBlocks.map((block) => (
          <div key={block.label} className="text-center">
            <div className="bg-[#0A0A0F] border border-[#27272A] rounded-md p-3">
              <span className="font-mono text-2xl sm:text-3xl font-bold text-[#F4F4F5]">
                {String(block.value).padStart(2, "0")}
              </span>
            </div>
            <p className="text-[10px] text-[#71717A] mt-1 uppercase tracking-wider">{block.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
